/**
 * IM消息列表
 * author: jiaheming
 * date: 2019/06/12
 */
import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import actions from '../../actions';
import { updateShowChat } from '../../actions/actionCreators';
import config from '../../config';

const ListItemStyle = styled.div`
    position: relative;
    cursor: pointer;
    width: 100%;
    height: 80px;
    display: flex;

    div {
        box-sizing: border-box;
    }

    .im-item-left {
        position: relative;
        flex: none;
        height: 80px;
        width: 80px;
        padding: 17px;

        .im-item-img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
            overflow: hidden;
            background: transparent url(${props => props.url}) no-repeat center;
            background-size: cover;
            margin-top: 0;
            transition: all 0.5s;

            &.im-item-show {
                margin-top: -10px;
                transition: all 0.5s;
            }
        }

        .show-name {
            position: absolute;
            bottom: 3px;
            left: 0;
            width: 100%;
            text-align: center;
            padding: 0 5px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            opacity: 0;
            height: 22px;
            font-size: 14px;
            font-weight: 500;
            color: rgba(102, 102, 102, 1);
            line-height: 22px;
            transition: all 0.5s;
            &.im-item-show {
                opacity: 1;
                transition: all 0.5s;
            }
        }

        .show-unread {
            position: absolute;
            top: 10px;
            right: 15px;
            width: 8px;
            height: 8px;
            background: rgba(245, 34, 45, 1);
            border: 1px solid rgba(245, 34, 45, 1);
            border-radius: 50%;
            opacity: 0;
            transition: all 0.5s;

            &.im-item-show {
                opacity: 1;
                transition: all 0.5s;
            }
        }
        transition: all 0.5s;
    }
    .im-item-mid {
        width: 178px;
        max-width: 178px;
        flex: 1 1 auto;
        padding: 20px 0;

        .im-item-name {
            width: 100%;
            height: 22px;
            font-size: 14px;
            font-weight: 500;
            color: rgba(51, 51, 51, 1);
            line-height: 22px;
            text-overflow: ellipsis;
            overflow: hidden;
        }

        .im-item-msg {
            width: 100%;
            height: 22px;
            font-size: 12px;
            font-weight: 400;
            color: rgba(140, 140, 140, 1);
            line-height: 22px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
    }

    .im-item-right {
        flex: none;
        height: 100%;
        padding: 20px 14px;

        .im-item-time {
            width: 100%;
            height: 22px;
            font-size: 12px;
            color: rgba(153, 153, 153, 1);
            line-height: 22px;
        }

        .unread {
            height: 20px;
            background: rgba(245, 34, 45, 0.9);
            box-shadow: 0px 4px 6px 0px rgba(242, 193, 195, 1);
            border: 1px solid transparent;
            border-radius: 10px;
            font-size: 11px;
            color: rgba(255, 255, 255, 1);
            line-height: 20px;
            text-align: center;
        }
    }

    &.im-item-active {
        background: rgba(234, 234, 234, 1);

        &::before {
            content: '';
            width: 3px;
            height: 70px;
            background: rgba(45, 128, 241, 0.5);
            display: block;
            position: absolute;
            top: 5px;
            left: 0;
            transition: all 0.5s;
        }
        transition: all 0.5s;
    }
`;

class IMItem extends React.Component {
    render() {
        const {
            session,
            setCurrSession,
            updateShowChat,
            showChat,
            currSessionId,
            resetNoMoreHistoryMsgs,
        } = this.props;
        return (
            <ListItemStyle
                className={currSessionId === session.id ? 'im-item-active' : ''}
                onClick={() => {
                    if (currSessionId !== session.id) {
                        setCurrSession(session.id);
                        updateShowChat(true);
                        resetNoMoreHistoryMsgs();
                    }
                }}
                url={session.avatar}
            >
                <div className="im-item-left" title={session.name}>
                    <div className={`im-item-img ${showChat ? 'im-item-show' : ''}`} />
                    <div className={`show-name ${showChat ? 'im-item-show' : ''}`}>{session.name}</div>
                    <div className={`show-unread ${session.unread > 0 && showChat ? 'im-item-show' : ''}`} />
                </div>
                <div className="im-item-mid">
                    <div className="im-item-name">{session.name}</div>
                    <div className="im-item-msg">{session.lastMsgShow}</div>
                </div>
                <div className="im-item-right">
                    <div className="im-item-time">{session.updateTimeShow}</div>
                    {session.unread > 0 ? (
                        <div className="unread">{session.unread > 99 ? '99+' : session.unread}</div>
                    ) : null}
                </div>
            </ListItemStyle>
        );
    }
}

function mapStateToProps(store) {
    const {
        showChat,
        imStore: { currSessionId },
    } = store[config.reduxStoreName];
    return {
        showChat,
        currSessionId,
    };
}

export default connect(mapStateToProps, {
    setCurrSession: actions.setCurrSession,
    resetNoMoreHistoryMsgs: actions.resetNoMoreHistoryMsgs,
    updateShowChat,
})(IMItem);
